import { Image } from '@mui/icons-material';
import BatchScheduleShow from './BatchScheduleShow';
export default {
    show: BatchScheduleShow,
    icon: Image,
};
